import { useEffect } from "react";
import { loginSelector } from "@/store/features/loginSlice";
import { subscribeFirebase, unsubscribeFirebase } from "./firebaseSubscribe";
import { setPageEvent } from "@/store/features/dashboardSlice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@/store/store";
import { toastMessage } from "@/utils/helper/myToast";
import moment from "moment";

const useFireBaseRTDB = () => {
  const dispatch = useAppDispatch();
  const { currentOrg, currentUser } = useSelector(loginSelector);

  useEffect(() => {
    if (!currentOrg || !currentUser) return;

    const path = `/lystproof/${currentOrg?.SignupOrg?.ext_org_id}/${currentUser?.user_ext_id}/notifications`;

    subscribeFirebase(path, (data, error) => {
      // console.log("Firebase subscription callback triggered", { path });
      if (error) {
        // handle error
        console.log("Error fetching data:", error);
      } else {
        // use data
        // console.log("Firebase Fetched data:", data);
        if (data) {
          if (data?.data?.toast && data?.time && moment(data?.time).isAfter(moment().subtract(1, "minute"))) {
            const { message, isError } = data.data.toast;
            toastMessage(message, isError);
          }
          const keys = ["notifications"];
          if (data?.data?.keys) {
            keys.push(...data.data.keys);
          }
          dispatch(setPageEvent({ keys, type: "refresh" }));
          setTimeout(() => {
            dispatch(setPageEvent(null));
          }, 5000);
        }
      }
    });
    // Cleanup function
    return () => {
      unsubscribeFirebase(path);
    };
  }, [currentOrg, currentUser]);
};

export default useFireBaseRTDB;
